import { FileIcon, FileTextIcon, ImageIcon } from 'lucide-react'

/**
 * Pick an icon based on a file's mimeType. Images get a picture icon,
 * PDFs/DOCX get a document-with-lines icon. Falls back to the generic file
 * icon for anything unrecognized.
 */
export function FileTypeIcon({
  mimeType,
  className,
}: {
  mimeType: string
  className?: string
}) {
  if (mimeType.startsWith('image/')) return <ImageIcon className={className} />
  if (
    mimeType === 'application/pdf' ||
    mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ) {
    return <FileTextIcon className={className} />
  }
  return <FileIcon className={className} />
}
